import { AddressType, fetchAddressList, type Address } from "@/services/addresses";
import { ApiClient } from "@/services/apiClient";
import { UserNotFoundException } from "@/services/user";
import { type UserProfile } from "@/services/user/profile/types";
import { type AxiosError } from "axios";

export async function fetchUserProfile(nickname: string): Promise<UserProfile> {
  const params = { nickname };
  const url = `api-public/user/collector`;
  return ApiClient.getPublic<UserProfile>(url, params)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      const status = error.response?.status;
      if (status === 404) {
        throw new UserNotFoundException();
      } else {
        throw error;
      }
    });
}

export async function fetchUserAddress(): Promise<Address | undefined> {
  // API returns a list, we want only one
  return fetchAddressList(AddressType.Personal).then((addressList) => {
    return addressList.shift();
  });
}
